import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
/**
 * Components
 */
import LayoutWithList from "../../../../LayoutModal/WithList";
import ActionButton from "../../../../Button/ActionButton";
import Loading from "../../../../Loading";
/**
 * hooks
 */
import apiRequest from "../../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../../hooks/useLoading";
/**
 * Intefaces
*/
import { ICreate, Inputs } from "Interfaces/IAdicao";
import LayoutModal from "../../../../../components/LayoutModal";

export default function UpdateAdicao({
  isOpenModalQtd,
  setModalClose,
  updateList,

  selectedUrlId,
  selectedSpherId,
  selectedCylinId,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        if (selectedUrlId !== null) {
          const response = await axiosInstance.get(
            `multifocal-lens/${selectedUrlId}`
          );

          const addressData = response.data;
          for (const key in addressData) {
            setValue(key as keyof Inputs, addressData[key]);
          }
        } else {
          console.log("Dado não encontrado!");
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    fetchData();
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        left: data.left,
        right: data.right,
        cropped_lens_left: data.cropped_lens_left,
        cropped_lens_right: data.cropped_lens_right
      }

      const response = await apiRequest(
        `multifocal-lens/${selectedUrlId}`,
        "PATCH",
        payload
      );
      if (response.status === 200) {
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o antirreflexo.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalQtd) {
    return (
      <LayoutModal
        title="Atualizar Quantidade"
        subTitle="Atualize as informações da quantidade em sua base de dados."
        setModalClose={setModalClose}
        statusLoad={false}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <p>Esférico: {selectedSpherId} / Adição: {selectedCylinId}</p>
            <S.Forms>
              <S.SeparateDiv>
                <S.FormInput>
                  <S.Label>
                    Esquerda
                    <span>*</span>
                  </S.Label>
                  <S.Input
                    placeholder="0"
                    type="number"
                    {...register("left")}
                  />
                  {errors.left && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>

                <S.FormInput>
                  <S.Label>
                    Quantidade Cortada
                  </S.Label>
                  <S.Input
                    placeholder="0"
                    type="number"
                    {...register("cropped_lens_left")}
                  />
                </S.FormInput>
              </S.SeparateDiv>

              <S.SeparateDiv>
                <S.FormInput>
                  <S.Label>
                    Direita
                    <span>*</span>
                  </S.Label>
                  <S.Input
                    placeholder="0"
                    type="number"
                    {...register("right")}
                  />
                </S.FormInput>

                <S.FormInput>
                  <S.Label>
                    Quantidade Cortada
                  </S.Label>
                  <S.Input
                    placeholder="0"
                    type="number"
                    {...register("cropped_lens_right")}
                  />
                </S.FormInput>
              </S.SeparateDiv>
            </S.Forms>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
